import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Login from "../auth/Login";
import Exception from "../common/Exception";
import AppProps from "../../static/js/AppProps";

export const responseForFetchProducts = async () => {
    return fetch(
        `${AppProps.spring_server_url}/shopping-cart`,
        {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${localStorage.getItem("token")}`,
            },
        }
    );
};

export function ShoppingCart() {
    const [shoppingCart, setShoppingCart] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [isAgreed, setIsAgreed] = useState(false);
    const [pdfToShow, setPdfToShow] = useState(null); // для модалки с PDF
    const navigate = useNavigate();

    useEffect(() => {
        const token = localStorage.getItem("token");
        if (!token) {
            navigate(Login.link);
            return;
        }

        const fetchProducts = async () => {
            const response = await responseForFetchProducts();
            if (response.ok) {
                setShoppingCart(await response.json());
            } else {
                console.log(`Ошибка: ${response.status}`);
            }
        };
        fetchProducts().then(_ => {});
    }, [navigate]);

    const handleDelete = async (productId) => {
        const response = await fetch(
            `${AppProps.spring_server_url}/shopping-cart?product=${productId}`,
            {
                method: "DELETE",
                headers: {
                    "Authorization": `Bearer ${localStorage.getItem("token")}`,
                },
            }
        );
        if (response.ok) {
            setShoppingCart((prev) => prev.filter((item) => item.id !== productId));
        } else {
            alert(await response.text());
        }
    };

    const handleCheckout = async () => {
        if (shoppingCart.length === 0) return;
        setIsLoading(true);

        const response = await fetch(
            `${AppProps.flask_server_url}/buy`,
            {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${localStorage.getItem("token")}`,
                },
            }
        );

        setIsLoading(false);
        if (response.ok) {
            let body = await response.json();
            window.location.replace(body.url);
        } else {
            navigate(Exception.link);
        }
    };

    const openPdfModal = (pdfPath) => {
        setPdfToShow(pdfPath);
    };

    const closePdfModal = () => {
        setPdfToShow(null);
    };

    return (
        <div className="container py-4">
            <div className="row justify-content-center">
                <div className="col-md-8">
                    <div className="card shadow-lg p-4">
                        <h3 className="text-primary display-5 text-center mb-4">Корзина</h3>

                        {shoppingCart.length === 0 ? (
                            <p className="text-center">Корзина пуста.</p>
                        ) : (
                            <>
                                <ul className="list-group mb-3">
                                    {shoppingCart.map((product) => (
                                        <li
                                            key={product.id}
                                            className="form-control d-flex justify-content-between align-items-center"
                                        >
                                            <Link
                                                to={`/product/${product.id}`}
                                                className="text-decoration-none flex-grow-1"
                                                style={{ color: "inherit" }}
                                            >
                                                <div>
                                                    <strong>{product.full_name}</strong> –{" "}
                                                    <span>{product.price}₽</span>
                                                </div>
                                            </Link>
                                            <button
                                                className="btn btn-outline-danger btn-sm"
                                                onClick={() => handleDelete(product.id)}
                                            >
                                                Удалить
                                            </button>
                                        </li>
                                    ))}
                                </ul>

                                <div className="mb-2 d-flex align-items-center justify-content-center">
                                    <input
                                        type="checkbox"
                                        id="agreePrivacy"
                                        checked={isAgreed}
                                        onChange={(e) => setIsAgreed(e.target.checked)}
                                        className="me-2"
                                    />
                                    <small className="text-muted" style={{ userSelect: "none" }}>
                                        Нажимая на кнопку, вы соглашаетесь с условиями{" "}
                                        <span
                                            role="button"
                                            className="link text-primary"
                                            style={{ cursor: "pointer", textDecoration: "underline", marginRight: '10px' }}
                                            onClick={() => openPdfModal('/privacy_policy.pdf')}
                                        >
                                            Обработки Персональных Данных
                                        </span>
                                        и{" "}
                                        <span
                                            role="button"
                                            className="link text-primary"
                                            style={{ cursor: "pointer", textDecoration: "underline" }}
                                            onClick={() => openPdfModal('/user_agreement.pdf')}
                                        >
                                            Продажи
                                        </span>
                                        .
                                    </small>
                                </div>

                                <button
                                    className="btn btn-info display-4"
                                    onClick={handleCheckout}
                                    disabled={shoppingCart.length === 0 || isLoading || !isAgreed}
                                    style={{
                                        backgroundColor: (shoppingCart.length === 0 || isLoading || !isAgreed) ? 'grey' : undefined,
                                        borderColor: (shoppingCart.length === 0 || isLoading || !isAgreed) ? 'grey' : undefined,
                                        cursor: (shoppingCart.length === 0 || isLoading || !isAgreed) ? 'not-allowed' : 'pointer',
                                    }}
                                >
                                    Оплатить
                                </button>
                            </>
                        )}
                    </div>
                </div>

                {pdfToShow && (
                    <div
                        className="modal show d-block"
                        tabIndex="-1"
                        style={{ backgroundColor: "rgba(0, 0, 0, 0.5)" }}
                        onClick={closePdfModal}
                    >
                        <div className="modal-dialog modal-xl" onClick={e => e.stopPropagation()}>
                            <div className="modal-content" style={{ height: '90vh', display: 'flex', flexDirection: 'column' }}>
                                <div className="modal-header">
                                    <h5 className="modal-title">
                                        {pdfToShow === '/privacy_policy.pdf' ? 'Политика обработки персональных данных' : 'Пользовательское соглашение'}
                                    </h5>
                                    <button
                                        type="button"
                                        className="btn-close"
                                        onClick={closePdfModal}
                                    ></button>
                                </div>
                                <div className="modal-body" style={{ flex: 1, padding: 0, overflow: 'hidden' }}>
                                    <iframe
                                        src={pdfToShow}
                                        title="PDF Document"
                                        width="100%"
                                        height="100%"
                                        style={{ border: 'none' }}
                                    />
                                </div>
                                <div className="modal-footer">
                                    <button className="btn btn-secondary" onClick={closePdfModal}>Закрыть</button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}
